export default __webpack_public_path__ + "static/food-cutting-accomplishment-1-a0b0a63bf40d25f647e5b5ce6449e0e9.svg";